
import ENV from '../../../environment.json'
import environments from './environments'
export default environments[ENV.env]
